export default __webpack_public_path__ + "static/media/text-directions.201156d2.svg";